export default __webpack_public_path__ + "static/media/pending_mpp.e4fcdf55.svg";